import subscriptionsWidgetTemplate from './subscriptionsWidget.html';
import './subscriptionsWidget.scss';

export default angular
  .module('main.dashboardPanel.subscriptionsWidget', [])

  .directive('subscriptionsWidget', () => {
    return {
      restrict: 'E',
      template: subscriptionsWidgetTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   DashboardDataProvider) => {
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getSubscriptionsLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                return;
              }

              $scope.data =
                reportInfo.executions
                  .slice()
                  .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                  .pop()
                  .data
                  .map(datum => ({
                    data: datum.value || 0,
                    label: reportInfo.dictionary?.find(d => JSON.stringify(d.id) === JSON.stringify(datum.id))?.name
                  }));
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
